module.exports = __webpack_public_path__ + "static/media/Lamin Mansaray.ee5819cf.png";